var Block_Slider_Logo = {

    espace_defilement:0,
    position_defilement:0,
    vitesse_defilement:0.5,

    init:function(){
        $(window).resize(function(){
            Block_Slider_Logo.resize();
        });
        Block_Slider_Logo.resize();

        if(Block_Slider_Logo.espace_defilement != 0) {
            setInterval(function () {
                Block_Slider_Logo.move_logos();
            }, 10);
        }
    },
    resize:function(){
       $(".block-slider-logo .logos-defil").html("");
       var _init_logos = $(".block-slider-logo .logos-init").html();
       Block_Slider_Logo.espace_defilement = $(".block-slider-logo .logos-init").width();

       Debug.log("LENGTH SLIDER LOGO : " + Block_Slider_Logo.espace_defilement );

        if(Block_Slider_Logo.espace_defilement != 0) {
            var _nb_loop = 2 + Math.floor($(window).outerWidth() / Block_Slider_Logo.espace_defilement);

            Debug.log("INIT LOGOS : " + _nb_loop);

            for (var i = 0; i < _nb_loop; i++) {
                $(".block-slider-logo .logos-defil").append(_init_logos);
            }
        }

    },
    move_logos:function(){
        if(Block_Slider_Logo.position_defilement > (Block_Slider_Logo.espace_defilement-Block_Slider_Logo.vitesse_defilement)){
            Block_Slider_Logo.position_defilement = 0;
        }else{
            Block_Slider_Logo.position_defilement += Block_Slider_Logo.vitesse_defilement;
        }

        $(".block-slider-logo .logos-defil").css({left:(-1 * Block_Slider_Logo.position_defilement) + "px"});
    }
}

$(window).load(function(){
    if($(".block-slider-logo").length){
        Block_Slider_Logo.init();
    }
})